export const isPlainLeftClick = (event)=>event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
